const styleSheet = (theme: any) => ({
  card: {
    margin: "0",
    width: (props: any) =>
      (props.overrideStyles && props.overrideStyles.width) || "100%",
    height: (props: any) =>
      (props.overrideStyles && props.overrideStyles.height) || "100%",
    borderRadius: (props: any) =>
      (props.overrideStyles && props.overrideStyles.borderRadius) || "4px",
    backgroundColor: "#ffffff",
    boxShadow: (props: any) =>
      (props.overrideStyles && props.overrideStyles.boxShadow) ||
      "0 2px 4px 0 rgba(0,0,0,0.15)",
    display: "inline-block",
    "& li": {
      color: "#6373A4",
      padding: "1em 0",
      borderBottom: "1px solid #DADEE9"
    },
    "& h2": {
      display: "inline-block",
      color: "#051D39",
      fontSize: "24px",
      lineHeight: "30px"
    },
    "&:hover": {
      cursor: (props: any) =>
        (props.overrideStyles && props.overrideStyles.cursor) || "auto",
      boxShadow: (props: any) =>
        (props.overrideStyles && props.overrideStyles.hoverBoxShadow) ||
        (props.overrideStyles && props.overrideStyles.boxShadow) ||
        "0 2px 4px 0 rgba(0,0,0,0.15)"
    }
  },
  wrapper: {
    paddingTop: (props: any) =>
      (props.overrideStyles && props.overrideStyles.paddingTop) || "35px",
    paddingBottom: (props: any) =>
      (props.overrideStyles && props.overrideStyles.paddingBottom) || "24px",
    paddingLeft: (props: any) =>
      (props.overrideStyles && props.overrideStyles.paddingLeft) || "40px",
    paddingRight: (props: any) =>
      (props.overrideStyles && props.overrideStyles.paddingRight) || "40px",
    height: "100%",
    "& h2": {
      marginBottom: (props: any) =>
        (props.overrideStyles && props.overrideStyles.h2MarginBottom) || "26px"
    }
  },
  iconHolder: {
    width: "46px",
    height: "46px",
    overflow: "hidden",
    marginRight: "12px",
    float: "left",
    "& img": {
      width: "100%"
    }
  },
  center: {
    marginBottom: (props: any) =>
      (props.overrideStyles && props.overrideStyles.h2MarginBottom) || "26px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& h2": {
      marginBottom: "0 !important"
    }
  },
  cogIcon: {
    background: "transparent",
    border: 0
  }
});

export default styleSheet;
try {
    // @ts-ignore
    styles.displayName = "styles";
    // @ts-ignore
    styles.__docgenInfo = { "description": "", "displayName": "styles", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/hoc/Card/styles.ts#styles"] = { docgenInfo: styles.__docgenInfo, name: "styles", path: "src/shared/hoc/Card/styles.ts#styles" };
}
catch (__react_docgen_typescript_loader_error) { }